module.exports = __webpack_public_path__ + "feature04.png?9fe48a7b574899184efd9fe1a20fd683";


//////////////////
// WEBPACK FOOTER
// ./src/assets/feature04.png
// module id = 103
// module chunks = 0